function isMediaQuerySelector(property) {
  return property.substr(0, 6) === '@media';
}
export { isMediaQuerySelector };